import React, { Component } from "react";
import questionMarkIcon from "../../../../../assets/images/flashcard_questionmark.png";

class MMGCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  clicked(cardItem) {
    this.props.click(cardItem);
  }
  render() {
    return (
      <div
        className={
          "card" +
          (!this.props.close ? " opened" : "") +
          (this.props.complete ? " matched" : "")
        }
        onClick={() => this.clicked(this.props.cardItem)}
      >
        <div className="front ">
          <img src={questionMarkIcon} alt="question-mark" />
        </div>
        <div className="back ">
          {this.props.cardItem.answerType === "P" ? (
            <img
              src={
                this.props.questionSetDetails.QSResourcePath +
                this.props.cardItem.name
              }
              alt="graphic"
            />
          ) : (
            this.props.cardItem.name
          )}
        </div>
      </div>
    );
  }
}

export default MMGCard;
